

























import { Component, Vue } from 'vue-property-decorator';
import '@/styles/MCQ.scss';
import {GeneralService} from '../services/general-service';
import config from '../services/api-config';
import router from '../router';
import store from '../store';


@Component({
  components: {
  }
})

export default class TestSelect extends Vue {
private service = new GeneralService();
private entities: GActivity[] = []; 
private level_id; 
private loaded = false;

public selectSubject(id, name){
    this.$store.state.selectSubject = id;
    this.$store.state.selectSubjectName = name;
    router.push('test-session');
}

getImgUrl(pet) {
    if (pet[pet.length - 1] == ' ') {
        pet = pet.substring(0, pet.length-1);
    }
    const images = require.context('@/assets/images/icons/', false, /\.svg$/);
    try{   
        return images('./' + pet + ".svg")
    } catch{
        // return images('./error.png')
    }
}

mounted() {
    this.level_id = localStorage[config.classLevl];

    if (this.level_id == '' || this.level_id == undefined || this.level_id == 'null') {
        router.push('select');
    }

    this.service.testsubjects(this.level_id)
        .then(result => {
             this.entities = result;
            this.loaded = true;
        })
        .catch(err => { console.error(`Error: ${err.message}`); 
    });

    const footer = document.getElementById('footer');

    if (footer !== null){
      footer.classList.add("mcqsubject");
    }
    
};

    
}

